import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
const useAuthorizedAttributes = (attributes) => {
  const currentUser = useCurrentUser();
  return attributes.filter(({ permissions }) => !(permissions == null ? void 0 : permissions.length) || isPermitted(currentUser.permissions, permissions));
};
export default useAuthorizedAttributes;
